import axios from 'axios';
import { appendDeepLinkingQueryParams } from '@factories/authentication';
import get from 'lodash/get';
import { loginEventTrack } from '@helpers/bloomreach-exponea';
import { ProfileInfo } from '@customTypes/ItemTypes';

axios.defaults.headers['Content-Type'] = 'application/json';

export async function getProfileInfo() : Promise<any> {
    try {
        const response = await axios.get('/services/auth/getUserProfile');
        const available_product_list = get(response, 'data.applications', null);
        const _datalayer_user = {
            company_name: get(response, 'data.company_name', null),
            language_preference_code: get(response, 'data.language_preference_code', null),
            title_code: get(response, 'data.title_code', null),
            job_function_code: get(response, 'data.job_function_code', null),
            applications: available_product_list,
        };
        window._datalayer_user = _datalayer_user;

        // Exponea / Bloomreach Script enable and Login event tracking
        const country_code = get(response, 'data.country_code', null);
        const email_id = get(response, 'data.email_address', null);
        const bloomreachLoggedInFlow = window.localStorage.getItem('bloomreachLoginFlow') || '';
        loginEventTrack(country_code, email_id, available_product_list, bloomreachLoggedInFlow);

        return { ...response.data };
    }
    catch (err) {
        console.log('error during Idaas info', err);
    }
}

export function updateProfileInfo(profileJson : ProfileInfo) : Promise<ProfileInfo> {
    const data = {
        firstName: profileJson.first_name,
        lastName: profileJson.last_name,
        phoneNumber: profileJson.phoneNumber,
        emailAddress: profileJson.email_address,
        userName: profileJson.userName,
        street: profileJson.street,
        city: profileJson.city,
        state: profileJson.state,
        postal_code: profileJson.postal_code,
        language_preference_code: profileJson.language_preference_code
    };
    // eslint-disable-next-line new-cap
    return axios.put('/services/auth/updateUserProfile', data)
        .then(() => (profileJson));
}

export function changePassword(currentPassword : string, newPassword : string, retypePassword : any) {
    return axios.put('/services/auth/changePassword', {
        currentPassword,
        newPassword,
        retypePassword
    })
        .then((result) => result.data)
        .catch((err) => {
            const resultData = (err?.response?.data?.error) ? err.response.data : null;
            if (resultData) {
                return Promise.reject(resultData);
            }
            return Promise.reject(new Error(''));
        });
}

export async function checkUserLogin() {
    const deepLinkingQueryUrl = appendDeepLinkingQueryParams('/services/auth/checkUserLogin');

    return deepLinkingQueryUrl && axios.get(deepLinkingQueryUrl)
        .then((res) => res.data);
}

export function lendioAuthentication(email: string) {
    const axiosCall = axios({
        method: 'POST',
        url: '/services/auth/lendioAuth',
        data: { email },
    });
    return axiosCall
        .then((result) => result.data)
        .catch((err) => {
            const resultData = (err?.response?.data?.error) ? err.response.data : null;
            if (resultData) {
                return Promise.reject(resultData);
            }
            return Promise.reject(new Error(''));
        });
}
